import "./Copyright.css";

function Copyright(props) {
  return <div className="copyright">{props.children}</div>;
}

export default Copyright;
